/*
 * HealthOS design tokens - GENERATED FROM tokens.json. Do not hand-edit.
 *
 * To change a value: update packages/tokens/src/tokens.json, then run
 *   pnpm --filter @healthos/tokens generate
 */

export const Colors = {
  paper: "#ffffff",
  black: "#000000",
  cream: "#f7f9f8",
  creamWarm: "#fbfaf6",
  creamDeep: "#f4f2ea",
  butter: "#f7efd1",
  navy: "#0a1f3a",
  navyDeep: "#061428",
  scrim: "#0a1f3a",
  ink: "#1b201e",
  inkSoft: "#2c3531",
  gray: {
    50: "#f6f7f8",
    100: "#eceef0",
    200: "#d9dde0",
    300: "#b8bfc4",
    400: "#6d727c",
    500: "#6a707c",
    600: "#4f5764",
    700: "#3a4150",
    800: "#232a36",
    900: "#172235"
  },
  purple: {
    50: "#eeedf8",
    100: "#ebe3fc",
    200: "#e2d5fb",
    300: "#cdbaf2",
    400: "#ac91e3",
    500: "#9971e5",
    600: "#4d1aad",
    700: "#320585",
    800: "#1e0056",
    900: "#15003d"
  },
  teal: {
    50: "#ecf8f9",
    100: "#d4eef0",
    200: "#a8dde1",
    300: "#74c4ca",
    400: "#459fa5",
    500: "#2a9098",
    600: "#14818f",
    700: "#0b6c79",
    800: "#075560",
    900: "#053338",
    leafPale: "#b7dde1",
    leafMid: "#87cfd4",
    leafCore: "#14818f",
    leafMass: "#459fa5"
  },
  care: {
    50: "#eff3f9",
    100: "#dde5f1",
    200: "#bccbe3",
    300: "#92a9cf",
    400: "#6884b6",
    500: "#4c6aa0",
    600: "#3d5a8a",
    700: "#324b75",
    800: "#283c5f",
    900: "#1c2a42"
  },
  blue: {
    50: "#eff6ff",
    100: "#dbeafe",
    200: "#bfdbfe",
    300: "#93c5fd",
    400: "#60a5fa",
    500: "#3b82f6",
    600: "#2563eb",
    700: "#1d4ed8",
    800: "#1e40af",
    900: "#1e3a8a"
  },
  amber: {
    50: "#fffbeb",
    100: "#fef3c7",
    200: "#fde68a",
    300: "#fcd34d",
    400: "#fbbf24",
    600: "#d97706",
    700: "#b45309",
    800: "#92400e",
    ink: "#8a5a2b"
  },
  rose: {
    50: "#fff1f2",
    100: "#ffe4e6",
    200: "#fecdd3",
    300: "#fda4af",
    400: "#fb7185",
    600: "#e11d48",
    700: "#be123c",
    800: "#9f1239"
  },
  orange: {
    50: "#fff7ed",
    100: "#ffedd5",
    200: "#fed7aa",
    300: "#fdba74",
    400: "#fb923c",
    500: "#f97316",
    600: "#ea580c",
    700: "#c2410c",
    800: "#9a3412",
    900: "#7c2d12"
  },
  leaf: {
    DEFAULT: "#4caf7d",
    dark: "#327b57",
    soft: "#e6f4ec"
  },
  mist: {
    DEFAULT: "#e8edeb",
    dark: "#c9d2cf",
    pale: "#e8edeb"
  },
  hair: {
    2: "#e8edeb",
    DEFAULT: "#dbe0dd"
  },
  ice: {
    50: "#f4fcff",
    100: "#e2f5fd",
    200: "#c2e9f8",
    300: "#9adcf3",
    400: "#6ec7e8",
    500: "#46abd6",
    600: "#2f8cbb",
    700: "#236f98",
    800: "#175373",
    900: "#0d3b53"
  },
  behaviour: {
    movement: "#14818f",
    sleep: "#5b6fb8",
    food: "#c2882a",
    stress: "#7a9477",
    connection: "#b5535b"
  },
  vivid: {
    amber: "#d97706",
    rose: "#e11d48",
    sky: "#2f8cbb",
    orange: "#ea580c",
    purple: "#9971e5",
    blue: "#2563eb",
    green: "#327b57",
    periwinkle: "#4c6aa0",
    pink: "#db2777"
  },
  topology: {
    edge: "#8aa0b1",
    grid: "#d8e3ea"
  },
  attention: {
    routine: {
      bg: "#f3f5f7",
      border: "#d9dde0",
      ink: "#4f5764"
    },
    timely: {
      bg: "#fff4e6",
      border: "#f5c98a",
      ink: "#b8530c"
    },
    urgent: {
      bg: "#fef2f2",
      border: "#fecaca",
      ink: "#991b1b"
    },
    surface1: "#3d6b6e",
    surface2: "#2f5559",
    surface3: "#244447",
    urgentSurface1: "#8a2f2f",
    urgentSurface2: "#6e2121",
    urgentSurface3: "#4a1414",
    routineSurface1: "#f7f9f8",
    routineSurface2: "#eef2f1",
    routineSurface3: "#e3e8e6"
  },
  ambient: {
    sleep: "#5b6fb8",
    energy: "#c2882a",
    calm: "#7a9477",
    strength: "#a8552c",
    heart: "#b5535b"
  },
  clinical: {
    sleep: "#3d5a8a",
    glp1: "#8a6228",
    cardio: "#2a5a5e"
  },
  chip: {
    recipe: "#a8552c",
    recipeBg: "#fdf3ed",
    recipeHover: "#8a4422",
    article: "#6b5b8a",
    story: "#8a5a3a",
    storyBg: "#faf3ec",
    reset: "#6b4a8a",
    resetBg: "#f5f0fa"
  },
  sleep: {
    deep: "#071724",
    core: "#087483",
    accent: "#83d2d8",
    cream: "#f3f8f6",
    mist: "#e2eeeb",
    glow: "#c4e7e4"
  },
  linen: "#efe9d8",
  sand: "#dccfa8",
  day: {
    dawn: "#fde9c7",
    morning: "#fbd9a3",
    twilight: "#c4b3b6",
    dusk: "#4a567a",
    night: "#1e2742",
    midnight: "#0f1428"
  },
  celebration: {
    emberDeep: "#1c1210",
    emberWarm: "#2b1a12"
  },
  night: {
    page: "#070d14",
    sheet: "#0a1018",
    surface: "#0f1a26",
    surfaceLifted: "#17232f",
    hair: "#1d2a37",
    border: "#2a3846",
    text: "#f2f5f8",
    textSecondary: "#a4aebb",
    textTertiary: "#74808f"
  },
  personalReset: {
    canvas: "#0a1320",
    editor: "#0a1424",
    player: "#050a14",
    error: "#ff9b9b"
  }
} as const;

export const Typography = {
  sans: "Inter Tight",
  serif: "Newsreader",
  serifItalic: "Newsreader_Italic",
  mono: "JetBrains Mono",
  sansFallback: "System",
  serifFallback: "Newsreader",
  size: {
    xs: 12,
    sm: 14,
    base: 16,
    md: 18,
    lg: 21,
    xl: 25,
    "2xl": 30,
    "3xl": 36,
    "4xl": 42
  },
  weight: {
    regular: "400",
    medium: "500",
    semibold: "600",
    bold: "700"
  },
  tracking: {
    tight: -0.5,
    normal: 0,
    caps: 1.2,
    capsLg: 1.8
  }
} as const;

export const Spacing = {
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  7: 28,
  8: 32,
  10: 40,
  12: 48,
  16: 64,
  px: 1,
  0.5: 2,
  1.5: 6
} as const;

export const Radius = {
  sm: 4,
  md: 8,
  lg: 12,
  xl: 16,
  "2xl": 24,
  modal: 28,
  full: 9999
} as const;

export const Motion = {
  duration: {
    fast: 120,
    base: 200,
    slow: 320,
    slower: 480,
    stagger: 60,
    instant: 0,
    tap: 120,
    gentle: 240,
    considered: 420,
    pressing: 160,
    ambient: 900
  }
} as const;
